module.exports = "../static/images/bfd899.png";